import React, { ReactElement } from "react";
import { PlanDetailSwiperCarousel } from "../planDetailCarousel";
import { type IContent } from "@kunduz/data-access-cms-api";
import styles from "./accordionCarousel.module.scss";

export const PlanDetailAccordionCarousel = (props: Props): ReactElement => {
  return (
    <>
      {props.data.title && <p className={styles.title}>{props.data.title}</p>}
      <PlanDetailSwiperCarousel
        items={
          props.data.items?.map((x) => ({
            kind: x.is_video ? "video" : "image",
            media: x.file || "",
            thumbnail: x.thumbnail || "",
          })) || []
        }
        width={160}
        height={90}
      />
    </>
  );
};

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
